import { Injectable } from '@angular/core'
import { SharedModule } from '@tv3/shared/shared.module'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { CreateAirbnbListingDialogComponent } from './create-airbnb-listing-dialog.component'

@Injectable({
  providedIn: SharedModule,
})
export class CreateAirbnbListingDialogService {
  constructor(private dialog: MatDialog) {}

  public open(channelId: string) {
    const defaultConfig: MatDialogConfig = {
      width: '500px',
      height: 'auto',
      data: { channelId },
      panelClass: ['fixed-modal'],
    }

    return this.dialog.open(CreateAirbnbListingDialogComponent, defaultConfig)
  }
}
